// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__1YYui","text":"SelectPayment_text__3cKLN","title":"SelectPayment_title__eAVdZ","btn":"SelectPayment_btn__1_ORS"};